export default "/_next/static/images/spanner-ef3cf67073b9ca0db1293397c52df0c8.svg";